// extracted by mini-css-extract-plugin
export default {"multiCardContainer":"category_multiCardContainer__MCes9","card":"category_card__N9UbV","active":"category_active__HEQxA"};